import { useEffect } from 'react'
import { useMedia } from './useMedia'

/** Botoes marcados com data-magnetic sao puxados de leve pelo cursor. */
export function useMagnetic() {
  const { reduced, isTouch } = useMedia()

  useEffect(() => {
    if (reduced || isTouch) return
    const botoes = Array.from(document.querySelectorAll<HTMLElement>('[data-magnetic]'))
    const limpezas: Array<() => void> = []

    botoes.forEach((botao) => {
      const aoMover = (e: MouseEvent) => {
        const r = botao.getBoundingClientRect()
        botao.style.translate =
          `${((e.clientX - r.left - r.width / 2) * 0.16).toFixed(1)}px ` +
          `${((e.clientY - r.top - r.height / 2) * 0.24).toFixed(1)}px`
      }
      const aoSair = () => { botao.style.translate = '' }

      botao.addEventListener('mousemove', aoMover)
      botao.addEventListener('mouseleave', aoSair)
      limpezas.push(() => {
        botao.removeEventListener('mousemove', aoMover)
        botao.removeEventListener('mouseleave', aoSair)
      })
    })

    return () => limpezas.forEach((f) => f())
  }, [reduced, isTouch])
}
